var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "chat" } }, [
    _c(
      "div",
      {
        staticClass: "chat-box-container",
        style: { top: _vm.position.top + "px", left: _vm.position.left + "px" },
      },
      [
        _c(
          "div",
          { staticClass: "chat-header", on: { mousedown: _vm.startDrag } },
          [
            _vm._v("\n            Locate2u AI\n            "),
            _c(
              "div",
              { staticClass: "close_container", on: { click: _vm.closeChat } },
              [_c("md-icon", { staticClass: "close_icon" }, [_vm._v("close")])],
              1
            ),
          ]
        ),
        _c(
          "div",
          { ref: "chatBody", staticClass: "chat-body" },
          _vm._l(_vm.messages, function (message, index) {
            return _c("div", { key: index }, [
              _c(
                "div",
                {
                  class: [
                    "message",
                    message.role === "User" ? "user-message" : "bot-message",
                  ],
                },
                [
                  message.role === "bot-typing"
                    ? [_vm._m(0, true)]
                    : [
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.compiledMarkdown(message.text)
                            ),
                          },
                        }),
                      ],
                ],
                2
              ),
              message.timeSent
                ? _c(
                    "div",
                    {
                      class: [
                        "message",
                        message.role === "User"
                          ? "user-message-time"
                          : "bot-message-time",
                      ],
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            message.timeSent.format(_vm.dateTypes.standardTime)
                          ) +
                          "\n                "
                      ),
                    ]
                  )
                : _vm._e(),
            ])
          }),
          0
        ),
        _c("div", { staticClass: "chat-footer" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.newMessage,
                expression: "newMessage",
              },
            ],
            ref: "inputElement",
            staticClass: "chat-input",
            attrs: { type: "text", placeholder: "Ask a question..." },
            domProps: { value: _vm.newMessage },
            on: {
              keydown: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.sendMessage($event)
              },
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.newMessage = $event.target.value
              },
            },
          }),
          _c(
            "button",
            { staticClass: "send-button", on: { click: _vm.sendMessage } },
            [_vm._v("Send")]
          ),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "typing-bubble" }, [
      _c("span"),
      _c("span"),
      _c("span"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }